/*
 * @Description: 
 * @Author: ywj
 * @Date: 2025-03-07 09:32:44
 * @LastEditTime: 2025-04-08 16:39:48
 * @LastEditors: ywj@originqc.com
 */
import React, { useEffect ,useState} from "react";
import NoData from '@/components/no-data'
import Card from './components/card'
import ChildHead from '../components/childHead'
import InvoiceModal from "./components/add-modal";
import DeleteModal from "../components/delete-modal";
import { getBillBaseList,deleteBill } from '@/api/personal-center'
import { message } from 'antd';
import './index.scss'
import { IInvoiceItem } from './type';


const Invoice: React.FC = () => {
  const [showAddModal, setShowAddModal] = React.useState(false)
  const [showDeleteModal, setShowDeleteModal] = React.useState(false);
  const [invoiceData, setInvoiceData] = useState<IInvoiceItem[]>([]);
  const [invoiceItem, setInvoiceItem] = useState<IInvoiceItem | null>();
  const [selectId, setSelectId] = useState<number>();
  
  useEffect(() => { 
    handleInvoiceData();
  },[showAddModal])
  const handleEdit = (obj:IInvoiceItem) => {
    setShowAddModal(true);
    setInvoiceItem(obj);
  }
  const handleDeletes = (id:number) => {
    setInvoiceItem(null)
    setShowDeleteModal(true);
    setSelectId(id);
    
  }
 
  const handleAddInvoice = () => { 
    if (invoiceData.length >10 ||invoiceData.length ===10 ) { 
      message.error('已存在10条发票抬头数据，请勿重复操作');
      return false;
    }
    setInvoiceItem(null)
    setShowAddModal(true);
  }

  const handleInvoiceData = () => { 
    getBillBaseList().then((res:any) => { 
      if (res?.success) {
        setInvoiceData(res.obj);
      } else { 
        message.error(res.message);
      }
    })
  }
 
  const haddleDeleteCard = () => { 
    if (selectId) { 
      deleteBill(selectId).then((res: any) => {
        if (res.success) {
          message.success('删除成功');
          setShowDeleteModal(false);
          handleInvoiceData();
        } else { 
          message.error(res.message);
        }
      })
    }
  }
  

  return <div className="invoice-container">
    <ChildHead
      title='开票信息'
      // subtitle='每个账号每种发票类型有效开票资质仅保存一个'
      rightText='新增发票抬头'
      callback={handleAddInvoice}
      disableHandleBtn={invoiceData.length >= 10}
    />
    {invoiceData.length>0?<div className="invoice-card-container">
      {invoiceData.map((item: IInvoiceItem) => {
        return <Card
          key={item.id}
          {...item}
          handleEdit={() => handleEdit(item)}
          handleDelete={() => handleDeletes(item?.id)}
          handleInvoiceData={handleInvoiceData}
        />
      })}
    </div>:<NoData/>}
    <InvoiceModal
      showModal={showAddModal}
      setShowAddModal={setShowAddModal}
      invoiceItem={invoiceItem ?? {} }
      
    />
    <DeleteModal
      showDeleteModal={showDeleteModal}
      setShowDeleteModal={setShowDeleteModal}
      handleDelete={haddleDeleteCard}
      title='删除提醒'
      content='请确认是否删除该发票抬头？'
      okText='是'
      cancelText='否'
    />
  </div>;
}

export default Invoice;
